// apiConfig.js

export const PAYSOFTER_API_URL = "https://api.paysofter.com";   
